export default "__VITE_PUBLIC_ASSET__bb8718f9__"